// extracted by mini-css-extract-plugin
module.exports = {"root":"no-results-module_root_1Q7My","icon":"no-results-module_icon_3bUCA","text":"no-results-module_text_DGYKZ"};